// import { instance, instanceEndUser } from "./service/instance";
import { apiSlice } from "../api/apiSlice";

export const CompanyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    companyList: builder.query<any, any>({
      query: (params) => {
        return {
          url: `/company/list`,
          params: params,
        };
      },
      providesTags: ["CompanyList"],
    }),
    // getUserAccRole: builder.mutation<any, any>({
    //   query: (params) => {
    //     return {
    //       url: `/user-admin/user-role-by-email`,
    //       method: "GET",
    //     };
    //   },
    //   invalidatesTags: ["GetUserAccRole"],
    // }),
    // createUserAcc: builder.mutation<any, any>({
    //   query: (body) => {
    //     return {
    //       url: `/user-admin/create`,
    //       method: "POST",
    //       body,
    //     };
    //   },
    //   invalidatesTags: ["CreateUserAcc", "UserAccList"],
    // }),
    // updateUserAcc: builder.mutation<any, any>({
    //   query: ({ id, body }) => {
    //     return {
    //       url: `/user-admin/update/${id}`,
    //       method: "PUT",
    //       body,
    //     };
    //   },
    //   invalidatesTags: ["UpdateUserAcc", "UserAccList"],
    // }),
    // deleteUserAcc: builder.mutation<any, any>({
    //   query: (id) => {
    //     return {
    //       url: `/user-admin/delete/${id}`,
    //       method: "DELETE",
    //     };
    //   },
    //   invalidatesTags: ["DeleteUserAcc", "UserAccList"],
    // }),
  }),
});

export const {
  useCompanyListQuery,
  // useCreateUserAccMutation,
  // useGetUserAccRoleMutation,
  // useUpdateUserAccMutation,
  // useDeleteUserAccMutation,
} = CompanyApiSlice;
